export const USER_STATUS = {
  NEW: "NEW",
  EXISTING: "EXISTING",
};

export const LEAD_DROP_STEPS = {
  MOBILE_NUMBER: "MOBILE_NUMBER",
  OTHER_DETAILS: "OTHER_DETAILS",
  OTP_VERIFICATION: "OTP_VERIFICATION",
  OTP_VERIFIED: "OTP_VERIFIED",
  LAST_SCREEN: "LAST_SCREEN",
  /** Lead drop popup/form variant 3: single-step "drop a query" form. */
  QUERY_FORM: "QUERY_FORM",
  QUERY_SUCCESS: "QUERY_SUCCESS",
};
